/* global d3, MarchingSquaresJS */
const colorArray = {
  0: "000,000,000",
  0.1: "067,067,067",
  0.15: "102,102,102",
  0.2: "153,153,153",
  0.3: "183,183,183",
  0.5: "204,204,204",
  0.75: "217,217,217",
  1: "103,078,167",
  1.5: "142,124,195",
  2: "180,167,214",
  3: "234,209,220",
  5: "213,166,189",
  7.5: "194,123,160",
  10: "166,077,121",
  15: "204,000,000",
  20: "224,102,102",
  30: "234,153,153",
  50: "244,204,204",
  75: "255,242,204",
  100: "255,229,153",
  150: "255,217,102",
  200: "241,194,050",
  300: "147,196,125",
  500: "106,168,079",
  750: "069,129,142",
  1000: "061,133,198",
  1500: "111,168,220",
  2000: "159,197,232",
  3000: "207,226,243",
  5000: "243,243,243",
  7500: "255,255,255",
};

function valueToHex(c) {
  var hex = parseInt(c).toString(16);

  return hex === "0" ? "00" : hex;
}
function rgbToHex(r, g, b) {
  return valueToHex(r) + valueToHex(g) + valueToHex(b);
}

export function createHeatmap(
  divId,
  heatmapRootWidth,
  pnts,
  ptsX,
  ptsY,
  actualX,
  actualY,
  maxValue,
  updatedHeight,
  disableXAxis,
  intervals,
  title,
  targetValue
) {
  console.log("DivIdDoc", divId + ":" + document.getElementById(divId));

  // removing heatmap to avoid duplicates when mounting/unmounting
  document.getElementById(divId).innerHTML = "";

  var data = [];

  // create 2D-Array
  for (var y = 0; y < ptsY; y++) {
    var tmpArr = [];
    for (var x = 0; x < ptsX; x++) {
      tmpArr.push(Number.parseFloat(pnts[y * ptsX + x].value));
    }
    data.push(tmpArr);
  }

  var xs = d3.range(0, data[0].length);
  var ys = d3.range(0, data.length);

  var isoBands = [];
  for (var i = 1; i < intervals.length; i++) {
    var lowerBand = intervals[i - 1];
    var upperBand = intervals[i];
    var band = MarchingSquaresJS.isoBands(data, lowerBand, upperBand - lowerBand, {
      successCallback: function () {
        //console.log('Band' + i + ':', band)
      },
      verbose: false,
    });
    isoBands.push({ coords: band, level: i, val: intervals[i] });
  }

  let colors = [];
  intervals.forEach((o) => {
    colors.push(colorArray[o]);
  });

  colors = colors.map((e) => {
    return "#" + rgbToHex(...e.split(","));
  });

  drawLines(divId, heatmapRootWidth, disableXAxis, isoBands, intervals, actualX, actualY, ptsX, ptsY, colors, title, targetValue);

  // helper function
  function drawLines(divId, heatmapRootWidth, disableXAxis, lines, intervals, actualX, actualY, dimX, dimY, colorArray, title, ypos) {
    var width = heatmapRootWidth;
    var height = 0;
    if (updatedHeight !== null) {
      height = updatedHeight;
    } else {
      height = width * (actualY / actualX);
    }

    var xScale = d3
      .scaleLinear()
      .range([0, width])
      .domain([Math.min.apply(null, xs), Math.max.apply(null, xs)]);

    var yScale = d3
      .scaleLinear()
      .range([0, height])
      .domain([Math.min.apply(null, ys), Math.max.apply(null, ys)]);
    var svg = d3
      .select("#" + divId)
      .append("svg")
      .attr("viewBox", `0 0 ${width + 60} ${height + 90}`);

    if (title) {
      svg.append("text").attr("x", 60)/*.style("font-size", "14px")*/.style("font-weight", "bold").attr("y", 20).text(title);
    }

    svg
      .selectAll("path")
      .data(lines)
      .enter()
      .append("path")
      .style("fill", function (d, i) {
        return colorArray[i];
      })
      .style("stroke", "#777")
      .style("opacity", 1.0)
      .attr("transform", `translate(60,30)`)
      .attr("d", function (d) {
        var p = "";
        d.coords.forEach(function (aa) {
          p +=
            d3
              .line()
              .x(function (dat) {
                return xScale(dat[0]);
              })
              .y(function (dat) {
                return yScale(dat[1]);
              })
              .curve(d3.curveLinear)(aa) + "Z";
        });
        return p;
      });

    let xOffset = actualX / (2 * dimX);
    let xScale1 = d3
      .scaleLinear()
      .domain([xOffset, actualX - xOffset])
      .range([0, width]);
    let xAxisGenerator = d3.axisBottom(xScale1);
    // fix x values
    let xAxisValues = [];
    for (let i = xOffset; i < actualX; i += 2 * xOffset) {
      xAxisValues.push(i);
    }
    xAxisGenerator.tickValues(xAxisValues).tickFormat(d3.format(".2f"));

    let yOffset = actualY / (2 * dimY);
    let yScale1 = d3
      .scaleLinear()
      .domain([actualY - yOffset, yOffset])
      .range([0, height]);
    // arrow on target value on y axis
    const arrowY = yScale1(targetValue);
    let yAxisGenerator = d3.axisLeft(yScale1);
    console.log("arrowY", arrowY, "targetValue", targetValue);
    if (ypos) {
      svg
        .append("line")
        .attr("x1", 0)
        .attr("y1", 30 + arrowY)
        .attr("x2", 10)
        .attr("y2", 30 + arrowY)
        .attr("stroke", "black")
        .attr("stroke-width", 4);
      svg
        .append("polygon")
        .attr("points", "0,0 10,5 0,10") // A small triangle shape
        .attr("transform", `translate(10, ${30 + arrowY - 5})`)
        // Explanation:
        // The axis starts at translate(30,30) for the y-axis.
        // We want the arrow near it, so we put it at x=20, which is slightly to the left of 30.
        // We center the arrow vertically around arrowY by subtracting half its height (~5).
        .attr("fill", "black");
    }
    svg
      .append("g")
      .attr("transform", `translate(60,${height + 40})`)
      .call(xAxisGenerator)
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-1em")
      .attr("dy", "0em")
      .attr("transform", "rotate(-60)");

    // fix y values
    let yAxisValues = [];
    for (let i = yOffset; i < actualY; i += 2 * yOffset) {
      yAxisValues.push(i);
    }
    yAxisGenerator.tickValues(yAxisValues).tickFormat(d3.format(".2f"));
    svg.append("g").attr("transform", `translate(50,30)`).call(yAxisGenerator);
  }
}

function legend_wrapped({
  divId,
  color,
  title,
  tickSize = 6,
  width = 320,
  height = 44 + tickSize,
  marginTop = 18,
  marginRight = 0,
  marginBottom = 16 + tickSize,
  marginLeft = 40,
  ticks = width / 64,
  tickFormat,
  tickValues,
} = {}) {
  const svg = d3
    .select("#" + divId)
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", [0, 0, width, height])
    .style("overflow", "visible")
    .style("display", "block");

  console.log("svg", svg);

  let tickAdjust = (g) => g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height);
  let x;

  // Continuous
  if (color.interpolate) {
    const n = Math.min(color.domain().length, color.range().length);

    x = color.copy().rangeRound(d3.quantize(d3.interpolate(marginLeft, width - marginRight), n));

    svg
      .append("image")
      .attr("x", marginLeft)
      .attr("y", marginTop)
      .attr("width", width - marginLeft - marginRight)
      .attr("height", height - marginTop - marginBottom)
      .attr("preserveAspectRatio", "none")
      .attr("xlink:href", ramp(color.copy().domain(d3.quantize(d3.interpolate(0, 1), n))).toDataURL());
  }

  // Sequential
  else if (color.interpolator) {
    x = Object.assign(color.copy().interpolator(d3.interpolateRound(marginLeft, width - marginRight)), {
      range() {
        return [marginLeft, width - marginRight];
      },
    });

    svg
      .append("image")
      .attr("x", marginLeft)
      .attr("y", marginTop)
      .attr("width", width - marginLeft - marginRight)
      .attr("height", height - marginTop - marginBottom)
      .attr("preserveAspectRatio", "none")
      .attr("xlink:href", ramp(color.interpolator()).toDataURL());

    // scaleSequentialQuantile doesn’t implement ticks or tickFormat.
    if (!x.ticks) {
      if (tickValues === undefined) {
        const n = Math.round(ticks + 1);
        tickValues = d3.range(n).map((i) => d3.quantile(color.domain(), i / (n - 1)));
      }
      if (typeof tickFormat !== "function") {
        tickFormat = d3.format(tickFormat === undefined ? ",f" : tickFormat);
      }
    }
  }

  // Threshold
  else if (color.invertExtent) {
    const thresholds = color.thresholds
      ? color.thresholds() // scaleQuantize
      : color.quantiles
        ? color.quantiles() // scaleQuantile
        : color.domain(); // scaleThreshold

    const thresholdFormat = tickFormat === undefined ? (d) => d : typeof tickFormat === "string" ? d3.format(tickFormat) : tickFormat;

    x = d3
      .scaleLinear()
      .domain([-1, color.range().length - 1])
      .rangeRound([marginLeft, width - marginRight]);

    svg
      .append("g")
      .selectAll("rect")
      .data(color.range())
      .join("rect")
      .attr("x", (d, i) => x(i - 1))
      .attr("y", marginTop)
      .attr("width", (d, i) => x(i) - x(i - 1))
      .attr("height", height - marginTop - marginBottom)
      .attr("fill", (d) => d);

    tickValues = d3.range(thresholds.length);
    tickFormat = (i) => thresholdFormat(thresholds[i], i);
  }

  // Ordinal
  else {
    x = d3
      .scaleBand()
      .domain(color.domain())
      .rangeRound([marginLeft, width - marginRight]);

    svg
      .append("g")
      .selectAll("rect")
      .data(color.domain())
      .join("rect")
      .attr("x", x)
      .attr("y", marginTop)
      .attr("width", Math.max(0, x.bandwidth() - 1))
      .attr("height", height - marginTop - marginBottom)
      .attr("fill", color);

    tickAdjust = () => {
      console.log("tickAdjust");
    };
  }

  svg
    .append("g")
    .attr("transform", `translate(0,${height - marginBottom})`)
    .call(
      d3
        .axisBottom(x)
        .ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined)
        .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
        .tickSize(tickSize)
        .tickValues(tickValues)
    )
    .call(tickAdjust)
    .call((g) => g.select(".domain").remove())
    .call((g) =>
      g
        .append("text")
        .attr("x", marginLeft + 4)
        .attr("y", marginTop + marginBottom - height - 6)
        .attr("fill", "currentColor")
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
        .text(title)
    );
  console.log(svg);
  return svg.node();
}

function ramp(color, n = 256) {
  var canvas = document.createElement("canvas");
  canvas.width = n;
  canvas.height = 1;
  const context = canvas.getContext("2d");
  for (let i = 0; i < n; ++i) {
    context.fillStyle = color(i / (n - 1));
    context.fillRect(i, 0, 1, 1);
  }
  return canvas;
}

export function legend(divId, title, scale) {
  let colors = [];
  scale.forEach((o) => {
    colors.push(colorArray[o]);
  });

  colors = colors.map((e) => {
    return "#" + rgbToHex(...e.split(","));
  });

  legend_wrapped({
    divId: divId,
    color: d3.scaleOrdinal(scale, colors),
    title: title,
    tickSize: 0,
    tickValues: scale,
    tickFormat: (d, i, threshold) => {
      if (i === 0 && threshold[0].__data__ > 0) {
        return "< " + threshold[0].__data__;
      } else {
        return d;
      }
    },
  });
}
